export default __webpack_public_path__ + "static/marineTraffic-thumbnail-1ec5dc936abc6b61f8a4473fe71cfecb.webp";